export default async function delay(delayInms: number, value?: any) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(value || null)
    }, delayInms)
  })
}
